import { useState, useEffect } from "react";
import { TextField, Button, Stack, Typography, Container, Alert } from "@mui/material";

export default function LogIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Log In | BNB Cleaning";
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Simulated login logic
    const isValid = email === "test@example.com" && password === "password123";

    if (!isValid) {
      setError("Incorrect email or password.");
    } else {
      setError("");
      console.log("Logging in:", email);
      // proceed with successful login
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 8, mb: 8 }}>
      <Stack flexDirection="column" alignItems="center">
        <Typography component="h1" variant="h2" fontWeight="bold">
          Log In
        </Typography>
        <Stack
          component="form"
          onSubmit={handleSubmit}
          sx={{ mt: 2 }}
          width="100%"
        >
          <TextField
            fullWidth
            label="Email"
            margin="normal"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            fullWidth
            label="Password"
            margin="normal"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}

          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ mt: 3 }}
          >
            Log In
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}
